import { css, cx } from "@emotion/css";
import { LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { DeploymentFreezeScopeOverview, DeploymentFreezeSummary, SummaryView } from "@octopusdeploy/octopus-server-client";
import { Leftovers } from "~/areas/tenants/components/DataTable/Cells/Leftovers";
import { EnvironmentChip } from "~/components/Chips/index";
interface DeploymentFreezeDataTableEnvironmentsCellProps {
    freeze: DeploymentFreezeSummary;
    hideTenantScope?: boolean;
}
export function DeploymentFreezeDataTableEnvironmentsCell({ freeze, hideTenantScope }: DeploymentFreezeDataTableEnvironmentsCellProps) {
    const findUniqueEnvironments = (scope: SummaryView<DeploymentFreezeScopeOverview>): {
        id: string;
        name: string;
    }[] => {
        const allEnvironments = scope?.Items.flatMap((p) => p.Environments.Items) || [];
        const uniqueEnvironments = new Map<string, {
            id: string;
            name: string;
        }>();
        allEnvironments.forEach((e) => {
            if (e && !uniqueEnvironments.has(e.Id)) {
                uniqueEnvironments.set(e.Id, { id: e.Id, name: e.Name });
            }
        });
        return Array.from(uniqueEnvironments.values());
    };
    const tenants = freeze.Tenants;
    const projects = freeze.Projects;
    const projectScopeEnvironments = findUniqueEnvironments(projects);
    const tenantScopeEnvironments = findUniqueEnvironments(tenants);
    const projectCount = projectScopeEnvironments.length > 1 ? projectScopeEnvironments.length - 2 : null;
    const tenantCount = tenantScopeEnvironments.length > 1 ? tenantScopeEnvironments.length - 2 : null;
    const hasNoEnvironments = !projectScopeEnvironments.length && !tenantScopeEnvironments.length;
    return (<LegacyDataTableRowColumn className={cx(cellStyles, "freeze-env-cell")}>
            <div>
                {projects?.Items.length > 0 && (<div className={cx(environmentSectionStyles, tenants?.Items.length > 0 && projectEnvironmentSectionStyles)}>
                        {projectScopeEnvironments.length > 0 ? (<>
                                {projectScopeEnvironments.slice(0, 2).map((e) => (<EnvironmentChip environmentName={e.name} key={e.id}/>))}
                                <Leftovers count={projectCount} name={"environment"} style={{ alignSelf: "center" }}/>
                            </>) : null}
                        {!projectScopeEnvironments.length && <div style={{ margin: "4px" }}>No environments</div>}
                    </div>)}
                {!hideTenantScope && tenants?.Items.length > 0 && (<div className={environmentSectionStyles}>
                        {tenantScopeEnvironments.length > 0 ? (<>
                                {tenantScopeEnvironments.slice(0, 2).map((e) => (<EnvironmentChip environmentName={e.name} key={e.id}/>))}
                                <Leftovers count={tenantCount} name={"environment"} style={{ alignSelf: "center" }}/>
                            </>) : null}
                        {!tenantScopeEnvironments.length && <div style={{ margin: "4px" }}>No environments</div>}
                    </div>)}
                {hasNoEnvironments && <div style={{ margin: space[4] }}>No environments</div>}
            </div>
        </LegacyDataTableRowColumn>);
}
const cellStyles = css({ width: "35%" });
const projectEnvironmentSectionStyles = css({
    display: "flex",
    borderBottom: `1px solid ${themeTokens.color.border.primary}`,
    marginBottom: space[8],
    paddingBottom: space[8],
});
const environmentSectionStyles = css({
    display: "flex",
    paddingRight: `${space[8]}`,
});
